import { render, staticRenderFns } from "./vipDetailOrder.vue?vue&type=template&id=2086f362&scoped=true"
import script from "./vipDetailOrder.vue?vue&type=script&lang=js"
export * from "./vipDetailOrder.vue?vue&type=script&lang=js"
import style0 from "./vipDetailOrder.vue?vue&type=style&index=0&id=2086f362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086f362",
  null
  
)

export default component.exports